
import React, { useState } from 'react';
import { Save, Lock } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';

const Settings: React.FC = () => {
    const { tenant } = useAuth();
    const [formData, setFormData] = useState({
        businessName: tenant?.businessName || '',
        email: tenant?.branding?.primaryColor || '',
    });

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Configurações</h1>
                    <p className="text-gray-500">Gerencie as informações da sua conta.</p>
                </div>
                <button className="bg-green-600 text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 hover:bg-green-700">
                    <Save size={18} /> Salvar Alterações
                </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <h2 className="text-lg font-bold text-gray-900 mb-4">Informações Gerais</h2>
                <div className="grid grid-cols-1 gap-6 max-w-2xl">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nome do Negócio</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 p-2 rounded-lg text-gray-900 bg-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                            value={formData.businessName}
                            onChange={(e) => setFormData({ ...formData, businessName: e.target.value })}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 opacity-70">
                 <div className="flex items-center gap-2 mb-4">
                    <h2 className="text-lg font-bold text-gray-900">Domínio Personalizado</h2>
                    <span className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded font-bold flex items-center gap-1">
                        <Lock size={10} /> PRO
                    </span>
                 </div>
                 <p className="text-gray-500 text-sm mb-4">Conecte seu próprio domínio (ex: www.suapousada.com.br) para remover a marca nossapesca.com.</p>
                 <button className="text-blue-600 font-bold hover:underline">Fazer Upgrade</button>
            </div>
        </div>
    );
};

export default Settings;
